<template>
    <div v-if="options.instanceRequired && formShown" class="btn border-primary text-primary">
        <div class="p-1">
            <Icon :v="options.icon || provider" set="b" />
            {{ options.name }}

            <form
                v-if="options.instanceRequired"
                :action="link"
                class="input-group my-2"
            >
                <input
                    ref="instance"
                    type="text"
                    name="instance"
                    class="form-control"
                    autofocus
                    required
                    :placeholder="$t(options.domain ? 'user.login.domainPlaceholder' : 'user.login.instancePlaceholder')"
                >
                <button type="submit" class="btn btn-outline-primary">
                    <Icon v="arrow-right" />
                </button>
            </form>
        </div>
    </div>
    <button
        v-else-if="options.instanceRequired && !formShown"
        class="btn btn-outline-primary p-2"
        @click="showForm"
    >
        <div class="p-1">
            <Icon
                :v="options.icon || provider"
                set="b"
                :class="[options.icon && options.icon.endsWith('.png') ? 'mx-1 invertible' : '']"
            />
            {{ options.name }}
        </div>
    </button>
    <a
        v-else-if="options.deprecated"
        :href="link"
        class="btn btn-outline-secondary btn-sm"
        @click.prevent="depreciationNotice(options.deprecated)"
    >
        <Icon :v="options.icon || provider" set="b" />
        {{ options.name }}
    </a>
    <a
        v-else-if="options.broken"
        :href="link"
        class="btn btn-outline-secondary btn-sm"
        @click.prevent="brokenNotice"
    >
        <Icon :v="options.icon || provider" set="b" />
        {{ options.name }}
    </a>
    <a
        v-else
        :href="link"
        class="btn btn-outline-primary"
    >
        <div class="p-1">
            <Icon :v="options.icon || provider" set="b" />
            {{ options.name }}
        </div>
    </a>
</template>

<script>
import useConfig from '../composables/useConfig.ts';
import useDialogue from '../composables/useDialogue.ts';
import useSocial from '../composables/useSocial.ts';

export default {
    props: {
        provider: { required: true },
        options: { required: true },
    },
    setup() {
        const { buildSocialLoginConnectLink } = useSocial();
        return {
            config: useConfig(),
            dialogue: useDialogue(),
            buildSocialLoginConnectLink,
        };
    },
    data() {
        return {
            formShown: false,
        };
    },
    computed: {
        link() {
            return this.buildSocialLoginConnectLink(
                this.config.locale,
                this.provider,
                this.options,
            );
        },
    },
    methods: {
        showForm() {
            this.formShown = true;
            this.$nextTick(() => this.$refs.instance.focus());
        },
        async depreciationNotice(link) {
            await this.dialogue.confirm(this.$t('user.login.depreciationNotice', { link }), 'warning');
            window.location.href = this.link;
        },
        async brokenNotice() {
            await this.dialogue.confirm(this.$t('user.login.brokenNotice'), 'warning');
            window.location.href = this.link;
        },
    },
};
</script>
